<template>
  <section class="sectionClass" v-if="context.item.modulprodukteprodukte?.produkte">
    <div class="container">
      <h2 class="section-title images__title">
        <span class="headline"> {{ context.item.modulprodukteueberschrift }} </span>
      </h2>

      <ul class="grid-auto grid-auto-4c images__list">
        <li
          class="grid-c images__list-item"
          v-for="produkt in context.item.modulprodukteprodukte.produkte"
          :key="produkt.url"
        >
          <a v-if="produkt.url" :href="produkt.url" :target="blank">
            <img class="images__image" :href="produkt.imageurl" :alt="produkt.imageAlternateText" />
          </a>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ModulProdukte',
  props: {
    context: {
      type: Object,
    },
  },
  computed: {
    sectionClass: function () {
      if (this.context.item.modulproduktestyle)
        return 'outer images images--4c section-styling-' + this.context.item.modulproduktestyle;
      return 'outer images images--4c section-styling-0';
    },
  },
};
</script>
